<template>
	<div class="dp-page">
		<div class="dp-inner">
			<!-- 返回 -->
			<div class="dp-bar">
				<span class="dp-back" @click="$emit('back')">
					<i class="dp-arrow"></i>返回
				</span>
			</div>

			<!-- 正文卡片 -->
			<div class="dp-card">
				<h1 class="dp-title">{{ detail.title || '无标题' }}</h1>
				<div class="dp-meta">
					<span v-if="detail.source" class="dp-source">来源：{{ detail.source }}</span>
					<span v-if="detail.date" class="dp-date">{{ detail.date }}</span>
				</div>
				<div class="dp-line"></div>
				<!-- 报告正文优先用富文本 HTML，新闻/无 HTML 时用纯文本 -->
				<div v-if="detail.html" class="dp-content dp-rich" v-html="detail.html"></div>
				<div v-else-if="detail.text" class="dp-content dp-text">{{ detail.text }}</div>
				<div v-else class="dp-empty">暂无正文内容</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'DetailPage',
		props: {
			// { title, source, date, html, text }
			detail: {
				type: Object,
				default: () => ({})
			}
		}
	}
</script>

<style scoped lang="scss">
	.dp-page {
		flex: 1;
		min-height: 0;
		overflow: auto;
		background: #f5f6f8;
		box-sizing: border-box;
	}

	.dp-inner {
		max-width: 1500px;
		margin: 0 auto;
		padding: 20px;
	}

	/* 返回栏 */
	.dp-bar {
		display: flex;
		align-items: center;
		margin-bottom: 14px;
	}

	.dp-back {
		display: inline-flex;
		align-items: center;
		font-size: 14px;
		color: #22b573;
		cursor: pointer;
		user-select: none;
	}

	.dp-back:hover {
		color: #1ea166;
	}

	.dp-arrow {
		width: 8px;
		height: 8px;
		margin-right: 6px;
		border-left: 2px solid #22b573;
		border-bottom: 2px solid #22b573;
		transform: rotate(45deg);
	}

	/* 卡片 */
	.dp-card {
		background: #fff;
		border: 1px solid #eee;
		border-radius: 6px;
		padding: 28px 32px 40px;
		box-sizing: border-box;
	}

	.dp-title {
		margin: 0;
		font-size: 22px;
		font-weight: 700;
		line-height: 1.5;
		color: #222;
		word-break: break-word;
	}

	.dp-meta {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 20px;
		margin-top: 14px;
		font-size: 13px;
		color: #999;
	}

	.dp-line {
		height: 1px;
		margin: 18px 0 22px;
		background: #f0f0f0;
	}

	/* 正文 */
	.dp-content {
		font-size: 16px;
		line-height: 2;
		color: #333;
		word-break: break-word;
	}

	/* 纯文本：保留换行 */
	.dp-text {
		white-space: pre-wrap;
	}

	/* 富文本：穿透 scoped 给上游 HTML 补基础排版 */
	.dp-rich ::v-deep p {
		margin: 0 0 1em;
		text-indent: 2em;
	}

	.dp-rich ::v-deep img {
		max-width: 100%;
		height: auto;
	}

	.dp-rich ::v-deep table {
		width: 100%;
		border-collapse: collapse;
	}

	.dp-rich ::v-deep td,
	.dp-rich ::v-deep th {
		border: 1px solid #e5e5e5;
		padding: 6px 10px;
	}

	.dp-empty {
		padding: 60px 0;
		text-align: center;
		font-size: 15px;
		color: #999;
	}
</style>
